import React, { useRef, useState } from "react";
import { View, StyleSheet } from "react-native";
import { Button, Divider } from "react-native-paper";
import LogoutButton from "../../components/LogoutButton";
import CompanyPickerDialog from "../../components/CompanyPickerDialog";
import { addDoc, collection, db } from "../../firebase";
import { useAppSelector } from "../../redux/store";
import type { Company } from "../../redux/slices/authSlice";
import { useTranslation } from "react-i18next";
import { NavigationProp } from "@react-navigation/native";
import { JOIN_REQUESTS_COLLECTION } from "../../constants/collections";
type CompanyOption = Pick<Company, "id" | "name">;

interface JoinCompanyScreenProps {
  navigation: NavigationProp<any>;
}

const JoinCompanyScreen = ({ navigation }: JoinCompanyScreenProps) => {
  const [selectedCompany, setSelectedCompany] = useState<CompanyOption | null>(
    null,
  );
  const [isCompanyPickerVisible, setIsCompanyPickerVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const isSubmittingRef = useRef(false);
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.auth.user);

  const handleSelectCompany = () => {
    setIsCompanyPickerVisible(true);
  };

  const handleCreateCompany = () => {
    navigation.navigate("CreateCompanyScreen");
  };

  const handleSubmit = async () => {
    if (isSubmittingRef.current) return;

    isSubmittingRef.current = true;
    setLoading(true);
    try {
      if (!selectedCompany) {
        alert(t("No company selected"));
        return;
      }

      const docRef = collection(db, JOIN_REQUESTS_COLLECTION);
      await addDoc(docRef, {
        createdAt: new Date(),
        updatedAt: new Date(),
        status: "PENDING",
        email: user.email,
        deleted: false,
        companyId: selectedCompany.id,
        userId: user.uid,
      });
      alert(t("Request sent"));
    } finally {
      isSubmittingRef.current = false;
      setLoading(false);
    }
  };

  return (
    <View style={styles.container}>
      <Button
        mode="outlined"
        onPress={handleSelectCompany}
        testID="select-company"
      >
        {selectedCompany?.name || t("Select company")}
      </Button>

      <Button
        mode="contained"
        onPress={handleSubmit}
        testID="submit"
        loading={loading}
        disabled={loading}
      >
        {t("Send")}
      </Button>

      <Divider />

      <Button mode="text" onPress={handleCreateCompany} testID="create-company">
        {t("Create new company")}
      </Button>
      <LogoutButton style={{ marginTop: "auto" }} />

      <CompanyPickerDialog
        visible={isCompanyPickerVisible}
        selectedCompany={selectedCompany}
        onDismiss={() => setIsCompanyPickerVisible(false)}
        onSelect={setSelectedCompany}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 16,
    padding: 20,
  },
});

export default JoinCompanyScreen;
